import { useEffect } from 'react';
import { motion, useMotionValue, useTransform, useSpring } from 'framer-motion';
import { useReducedMotion } from 'framer-motion';

/**
 * Animated number counter from 0 to `value`.
 * Uses Framer Motion spring for smooth transition.
 */
export default function PointsAnimation({
  value = 0,
  className = '',
  duration = 800,
  prefix = '',
  suffix = '',
  'data-testid': testId,
}) {
  const shouldReduce = useReducedMotion();
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, {
    duration: shouldReduce ? 0 : duration,
    bounce: 0,
  });
  const rounded = useTransform(springValue, (v) => Math.round(v));

  useEffect(() => {
    motionValue.set(value);
  }, [value, motionValue]);

  if (shouldReduce) {
    return (
      <span className={className} data-testid={testId}>
        {prefix}{value}{suffix}
      </span>
    );
  }

  return (
    <span className={className} data-testid={testId} aria-live="polite">
      {prefix}
      <motion.span>{rounded}</motion.span>
      {suffix}
    </span>
  );
}
